import { render, staticRenderFns } from "./InterfaceTokens.vue?vue&type=template&id=6f2f0eef&scoped=true&"
import script from "./InterfaceTokens.vue?vue&type=script&lang=js&"
export * from "./InterfaceTokens.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceTokens.vue?vue&type=style&index=0&id=6f2f0eef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2f0eef",
  null
  
)

export default component.exports